// State machine for calendar navigation
export type CalendarState =
  | 'INITIALIZING' // Component created, view not ready
  | 'READY' // View ready, idle
  | 'NAVIGATING' // Navigation in progress
  | 'REFRESHING'; // Data refresh in progress

// Navigation context to manage state
export class NavigationContext {
  state: CalendarState = 'INITIALIZING';
  previousSelectedDate: Date | null = null;
}

// Valid state transitions
export const VALID_TRANSITIONS: Record<CalendarState, CalendarState[]> = {
  INITIALIZING: ['READY', 'REFRESHING'],
  READY: ['NAVIGATING', 'REFRESHING'],
  NAVIGATING: ['READY'],
  REFRESHING: ['READY'],
};
